<template>
    <i class="vm-icon-collect afd pointer" :class="[data.has_mark == 1 ? 'on': 'black-3',data.has_mark == 1 ? 'afd-star-filled' : 'afd-star']" @click="tap"></i>
</template>

<script>
import {
  POST_USER_MARK_POST,
  POST_USER_UNMARK_POST,
} from '@/api/config';
import { mapState } from 'vuex';

export default {
    name: 'icon-collect',
    props: {
        data: {
            type: Object,
            default(){
                return {}
            }
        }
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        async tap() {
            let API = this.data.has_mark == 1 ? POST_USER_UNMARK_POST : POST_USER_MARK_POST;
            if (this.$http.is_run(API)) {
                return false;
            }
            let data = await this.$http.$axios(API, {
                post_id:this.data.post_id
            });

            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: 'error',
                });
                return false;
            }
            this.$emit(this.data.has_mark ? 'uncollect_success' : 'collect_success')
            this.$notify({
                title: data.em,
                group: 'success',
            });
            return true;
        },
    }
};
</script>

<style lang="stylus" scoped>
.vm-icon-collect{
    &.on{
        color:$orange;
    }
}
</style>
